module.exports = __webpack_public_path__ + "img/retnrn.cb43c48b.png";